import { Box, Button, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const ModalUser = styled(Box)({
	...flexMixin({ justify: 'space-between' }),
	width: '100%',
});

export const RemoveAccessButton = styled(Button)({
	backgroundColor: 'unset',
	color: 'rgb(251, 11, 36)',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: ' 157%',
	letterSpacing: '0.1px',
	borderRadius: '8px',
	padding: '10px 16px',
	textTransform: 'unset',
});

export const OwnerLabel = styled(Typography)({
	fontSize: '14px',
	fontWeight: 400,
	lineHeight: '143%',
	letterSpacing: '0.15px',
	color: '#707A8E',
});
